import { normalizeCollectionResponse, normalizeRecordResponse, templateDetailParams, templateParams } from 'api';
import { client, computeHeaders } from 'queries';

export const templateQuery = async ({ req, params }) => {
	const formattedParams = { ...templateDetailParams, context: ['cache', 'ssr'] };
	const headers = computeHeaders(req);
	const response = await client.apiRequest({
		url: `/templates/${params.templateId}`,
		headers,
		params: formattedParams,
	});
	return normalizeRecordResponse(response);
};

export const templatesQuery = async ({ req, query, rootApi = '' }) => {
	const formattedParams = { ...templateParams, context: ['ssr'], ...query };
	const headers = computeHeaders(req);
	const response = await client.apiRequest({ url: `${rootApi}/templates`, headers, params: formattedParams });
	return normalizeCollectionResponse(response);
};

const relatedTemplatesQuery = async ({ req, params, endpoint }) => {
	const headers = computeHeaders(req);
	const response = await client.apiRequest({
		url: `/templates/${params.templateId}/${endpoint}`,
		headers,
		params: { ...templateParams, context: ['cache', 'ssr'], pageSize: 8 },
	});
	return normalizeCollectionResponse(response);
};

export const similarTemplatesQuery = props => relatedTemplatesQuery({ ...props, endpoint: 'similar' });
export const ownerTemplatesQuery = props => relatedTemplatesQuery({ ...props, endpoint: 'owner-templates' });
